<template>
  <div class="md-layout md-alignment-center-center gray-6 bg">
    <div class="md-layout-item md-size-33">
      <email-verification-form />
    </div>
  </div>
</template>

<script>
import EmailVerificationForm from '../../components/auth/EmailVerificationForm';

export default {
  name: "EmailVerification",
  props: [],
  data: () => ({
    state: {
    },
  }),
  methods: {
  },
  components: {
    EmailVerificationForm,
  }
};
</script>

<style>
.header-content {
  flex-direction: column;
}
.logo {
  max-width: 100px;
}
</style>
